interface Props {
  file: string | File | null
  alt: string
}

export function IconPreview({ file }: Props) {
  if (!file) return null

  if (typeof file === 'string')
    return (
      <img
        src={file}
        className="absolute top-0 w-full h-full object-fill"
        alt="image"
      />
    )

  return (
    <img
      src={URL.createObjectURL(file)}
      className="absolute top-0 w-full h-full object-fill"
      alt="image"
    />
  )
}
